import React from 'react';
import styled, { keyframes } from 'styled-components';

const waveAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

const BackgroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
`;

const StripesContainer = styled.div`
  position: absolute;
  width: 200%;
  height: 100%;
  display: flex;
  flex-direction: column;
  animation: ${waveAnimation} 60s linear infinite;
  opacity: 0.03;
`;

const Stripe = styled.div`
  height: 7.69%; /* 100% / 13 stripes */
  background-color: ${props => props.red ? '#ff0000' : '#ffffff'};
`;

const PatrioticBackground = () => {
  return (
    <BackgroundContainer>
      <StripesContainer>
        {[...Array(13)].map((_, index) => (
          <Stripe key={index} red={index % 2 === 0} />
        ))}
      </StripesContainer>
    </BackgroundContainer>
  );
};

export default PatrioticBackground;
